import React, { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import ProductCarousel from "./ProductCarousel";

const ProductSlider = ({ products, onBuyNow, setResetFunction, quantities, setQuantities, allProducts }) => {
  const scrollRef = useRef(null);
  const scrollObserver = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [cardWidth, setCardWidth] = useState(0);
  //const [quantities, setQuantities] = useState({});
  const selectedProductsRef = useRef([]);

  // *** New useEffect to register reset function with App.js ***
  useEffect(() => {
    if (setResetFunction) {
      // Pass a function that sets quantities state back to an empty object
      // An empty quantities object means `quantities[product.id] || 1` will default to 1.
      setResetFunction(() => setQuantities({}));
    }
  }, [setResetFunction, setQuantities]); // Re-run if setResetFunction changes (should only happen once on mount)

  const minCardWidth = 280;
  const gap = 24;
  const containerPadding = 32;

  const updateLayout = () => {
    const container = scrollRef.current;
    if (!container) return;

    const usableWidth = container.clientWidth - containerPadding;
    let itemsPerView = Math.floor((usableWidth + gap) / (minCardWidth + gap));
    if (itemsPerView < 1) itemsPerView = 1;

    const totalGapWidth = (itemsPerView - 1) * gap;
    const calculatedCardWidth = (usableWidth - totalGapWidth) / itemsPerView;

    setCardWidth(calculatedCardWidth);
    setPageCount(Math.ceil(products.length / itemsPerView));
  };

  const scrollToPage = (index) => {
    const container = scrollRef.current;
    if (!container || cardWidth === 0) return;

    const usableWidth = container.clientWidth - containerPadding;
    const itemsPerView = Math.floor((usableWidth + gap) / (cardWidth + gap));
    const targetScrollLeft = index * (itemsPerView * (cardWidth + gap));

    setActiveIndex(index);
    container.scrollTo({ left: targetScrollLeft, behavior: "smooth" });
  };

  const handleQuantityChange = (productIndex, value) => {
    const newQuantity = Math.max(1, parseInt(value) || 1);
    setQuantities((prev) => ({ ...prev, [products[productIndex].productName]: newQuantity }));
  };

  useEffect(() => {
    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
    // eslint-disable-next-line
  }, [products.length]);

  useEffect(() => {
    // eslint-disable-next-line
    scrollToPage(0);
    // eslint-disable-next-line
  }, [cardWidth]);

  //const showPagination = products.length > 1 && pageCount > 1;

  // 🟢 Final Buy Now for All Selected
  const handleGlobalBuyNow = () => {
    const selected = allProducts.filter(product => quantities[product.productName] > 0)
      .map(product => {
        const quantity = quantities[product.productName];
        const productPriceNumeric = parseFloat(product.productPrice || '');
        const effectiveQuantity = quantity > 0 ? quantity : 1;
        const basePrice = productPriceNumeric * effectiveQuantity;

        let displayedPrice = basePrice;
        let hasValidOffer = false;
        let offerPercentage = 0;
        let flatTargetPrice = 0;

        if (product.productOffer) {
          const percentageMatch = product.productOffer.match(/(\d+(\.\d+)?)\s*%/);
          if (percentageMatch && percentageMatch[1]) {
            offerPercentage = parseFloat(percentageMatch[1]);
            if (!isNaN(offerPercentage) && offerPercentage > 0 && offerPercentage <= 100) {
              hasValidOffer = true;
            }
          }
          const flatMatch = product.productOffer.match(/₹\.?\s*(\d+)/i) || product.productOffer.match(/Flat\.?\s*(\d+)/i) || product.productOffer.match(/(\d+)\s*OFF/i);
          if (flatMatch && flatMatch[1]) {
            flatTargetPrice = (productPriceNumeric - parseFloat(flatMatch[1])) * effectiveQuantity;
            if (!isNaN(flatTargetPrice) && flatTargetPrice > 0) {
              hasValidOffer = true;
            }
          }
        }

        let potentialPrices = [basePrice];
        if (hasValidOffer) {
          if (offerPercentage > 0 && offerPercentage <= 100) {
            const priceAfterPercentageDiscount = basePrice * (1 - offerPercentage / 100);
            if (!(offerPercentage === 100 && flatTargetPrice > 0)) {
              potentialPrices.push(priceAfterPercentageDiscount);
            }
          }
          if (flatTargetPrice > 0) {
            potentialPrices.push(flatTargetPrice);
          }
        }
        displayedPrice = Math.max(0, Math.min(...potentialPrices));

        return {
          name: product.productName,
          quantity: quantity,
          price: displayedPrice
        };
      });
    console.log("Selected products inside handleGlobalBuyNow", selected);
    if (!selected.length) {
      alert("Please select at least one product.");
      return;
    }

    onBuyNow && onBuyNow(selected);
    selectedProductsRef.current = [];
  };
  // console.log("Start to Clear current selected product ref ", selectedProductsRef.current);
  // selectedProductsRef.current = []; 
  // console.log("Clears current selected product ref ", selectedProductsRef.current);
  return (
    <div className="relative">
      {pageCount > 1 && (
        <>
          <button
            onClick={() => scrollToPage((activeIndex - 1 + pageCount) % pageCount)}
            className="absolute left-2 top-1/2 z-10 bg-pink-400 text-white px-3 py-2 rounded-full shadow-lg hover:bg-pink-600 transform -translate-y-1/2"
          >
            ←
          </button>
          <button
            onClick={() => scrollToPage((activeIndex + 1) % pageCount)}
            className="absolute right-2 top-1/2 z-10 bg-pink-400 text-white px-3 py-2 rounded-full shadow-lg hover:bg-pink-600 transform -translate-y-1/2"
          >
            →
          </button>
        </>
      )}
      
      <div
        ref={scrollRef}
        className="flex overflow-x-auto gap-6 px-4 py-4 scroll-smooth hide-scrollbar snap-x snap-center"
      >
        
        {products.map((product, index) => {
          const quantity = quantities[product.productName] || 0;
          const productPriceNumeric = parseFloat(product.productPrice || ''); 
          //if (index === 0) selectedProductsRef.current = [];
          console.log("selected products: ", selectedProductsRef);
          if (isNaN(productPriceNumeric)) {
            console.error("Invalid product price for product:", product.productName, product.productPrice);
            return null;
          }
          const effectiveQuantityForDisplay = quantity > 0 ? quantity : 1;
          const originalTotalPriceForDisplay = productPriceNumeric * effectiveQuantityForDisplay;

         console.log(`--- Debugging for Product: ${product.productName} ---`);
         console.log(`Original Total Price (for calculations): ₹${(productPriceNumeric * quantity).toFixed(2)}`); // Keep this for actual total price based on selected quantity
         console.log(`Original Base Price (for display/unit basis): ₹${originalTotalPriceForDisplay.toFixed(2)}`);


          let offerPercentage = 0;
          // --- START: Declared flatTargetPrice variable ---
          let flatTargetPrice = 0;
          // --- END: Declared flatTargetPrice variable ---
          let hasValidOffer = false;

          if (product.productOffer) {
            // Regex to extract numeric percentage from formats like "50% OFF" or "50%"
            const percentageMatch = product.productOffer.match(/(\d+(\.\d+)?)\s*%/);
            if (percentageMatch && percentageMatch[1]) {
              offerPercentage = parseFloat(percentageMatch[1]);
              if (!isNaN(offerPercentage) && offerPercentage > 0 && offerPercentage <= 100) {
                hasValidOffer = true;
                console.log(`  - Detected Percentage Offer: ${offerPercentage}%`);
              }
            }

            // --- START: Logic to parse Flat Target Price from productOffer ---
            // This regex looks for "₹" followed by a number, or "Flat" followed by a number, or a number followed by "OFF"
            const flatMatch = product.productOffer.match(/₹\.?\s*(\d+)/i) || product.productOffer.match(/Flat\.?\s*(\d+)/i) || product.productOffer.match(/(\d+)\s*OFF/i);
            
            console.log(`  - Flat match: "${flatMatch}"`);
            console.log(`  - Product Offer String: "${product.productOffer}"`);
            console.log(`  - Flat Offer Regex Match Result:`, flatMatch); // Debugging the regex match

            const effectiveQuantityForFlat = quantity > 0 ? quantity : 1;

            if (flatMatch && flatMatch[1]) {
                console.log(`  - if block flatMatch && flatMatch[1]: "${flatMatch && flatMatch[1]}"`);
                flatTargetPrice = (productPriceNumeric - parseFloat(flatMatch[1])) * effectiveQuantityForFlat;
                console.log(`  - Flat target price: "${flatTargetPrice}"`);
                // Ensure the extracted flat target price is a valid number and greater than 0
                if (!isNaN(flatTargetPrice) && flatTargetPrice > 0) {
                    hasValidOffer = true; // Mark as valid offer if flat target price is found
                    console.log(`  - Detected Flat Target Price: ₹${flatTargetPrice.toFixed(2)}`);
                }
            }
            // --- END: Logic to parse Flat Target Price from productOffer ---
          }
          console.log(`  - Has Valid Offer Detected: ${hasValidOffer}`);


          // --- START: Modified displayedPrice calculation to include Flat Target Price ---
          let displayedPrice; // Start with the original price
          //let displayedTotalPrice = productPriceNumeric * quantity;
          let potentialPrices = []; // Collect all potential prices, including original

          // 🟡 Inject fallback for quantity = 0 to still show valid unit price
          const effectiveQuantity = quantity > 0 ? quantity : 1;
          const basePrice = productPriceNumeric * effectiveQuantity;
          potentialPrices = [basePrice]; // reset with fallback base price

          if (hasValidOffer) { // Only consider discounts if an offer was detected
            if (offerPercentage > 0 && offerPercentage <= 100) {
              const priceAfterPercentageDiscount = basePrice * (1 - offerPercentage / 100);
              if (!(offerPercentage === 100 && flatTargetPrice > 0)) {
                  potentialPrices.push(priceAfterPercentageDiscount);
                  console.log(`  - Calculated Price with Percentage Discount: ₹${priceAfterPercentageDiscount.toFixed(2)}`);
              } else {
                  console.log(`  - Percentage discount (100%) ignored due to Flat Target Price presence.`);
              }
            }

            if (flatTargetPrice > 0) {
              // According to your new logic, the flat target price is a potential final price
              //const effectiveQuantity = quantity > 0 ? quantity : 1;
              const flatPrice = flatTargetPrice;
              potentialPrices.push(flatPrice);
              console.log(`  - Calculated Price with Flat Target Price: ₹${flatPrice.toFixed(2)}`);
            }
          }

          // The final displayed price is the lowest among all potential options, ensuring it's not less than 0
          // This inherently handles prioritization: the lowest price wins.
          displayedPrice = Math.max(0, Math.min(...potentialPrices));

          // ✅ Collect selected products with final price
          if (quantity > 0) {
            const alreadyExists = selectedProductsRef.current.findIndex(
              (p) => p.name === product.productName
            );
            if (alreadyExists > -1) {
              // Update existing product's quantity and price if it's already in the ref
              selectedProductsRef.current[alreadyExists].quantity = quantity;
              selectedProductsRef.current[alreadyExists].price = displayedPrice;
            } else {
              // Add new product to the ref if it's not already there
              // IMPORTANT: Console logs here confirm the push happens for each selected product
              // from the currently rendered 'products' list.
              console.log("inside first else block before pushing selected ref current ", selectedProductsRef.current);
              selectedProductsRef.current.push({
                name: product.productName,
                quantity,
                price: displayedPrice
              });
              console.log("inside first else block after pushing selected ref current ", selectedProductsRef.current);
            }
          } else { // This 'else' belongs to the 'if (quantity > 0)'
            // If quantity is 0, remove the product from selectedProductsRef if it exists
            console.log("inside second else block selected ref current ", selectedProductsRef.current);
            selectedProductsRef.current = selectedProductsRef.current.filter(
              (p) => p.name !== product.productName
            );
          }

          console.log(`  - Final Displayed Price: ₹${displayedPrice.toFixed(2)}`);
          console.log(`-------------------------------------------------`);

          
          // --- END: Modified displayedPrice calculation to include Flat Target Price ---


          const showOffer = hasValidOffer;

          const displayQuantity = quantity > 0 ? quantity : 1;
          let priceToDisplayAsOriginal;
          if (showOffer) {
              // If there's an offer, the strikethrough price should be the original *unit* price.
              priceToDisplayAsOriginal = originalTotalPriceForDisplay;
          } else {
              // If no offer, the displayed price is the *total* original price for the quantity.
              priceToDisplayAsOriginal = originalTotalPriceForDisplay; // This is your originalTotalPrice
          }

          return (
            <motion.div
              key={index}
              className="snap-center flex-shrink-0 overflow-hidden bg-gradient-to-r from-pink-200 via-yellow-100 to-pink-100 rounded-3xl shadow-2xl p-6 hover:-translate-y-2 hover:shadow-pink-200 transition-transform duration-300 relative flex flex-col justify-between"
              style={{ width: `${cardWidth}px` }}
              whileHover={{ scale: 1.015 }}
              whileTap={{ scale: 0.98 }}
            >
              <div className="flex flex-col flex-grow min-h-[250px]">
                {product.productImages.length > 0 ? (
                  <ProductCarousel images={product.productImages} />
                ) : (
                  <img
                    src={product.productImages && product.productImages.length > 0 ? product.productImages[0] : '/placeholder.jpg'}
                    alt={product.productName}
                    className="w-full h-48 object-cover rounded-lg"
                  />
                )}
                <div className="text-center min-h-[100px] flex flex-col justify-center">
                  <h3 className="text-2xl font-bold text-pink-700 mt-4 mb-2">{product.productName}</h3>
                  <p className="text-gray-600 text-sm h-20 overflow-y-auto mb-2">{product.productDescription}</p>
                </div>
              </div>

              {/* Quantity Selector */}
              <div className="flex flex-col items-center justify-end gap-4 mt-2">
                <div className="flex items-center border rounded overflow-hidden">
                  <span className="text-sm text-gray-600 px-2">Quantity</span>
                  <button
                    onClick={() => handleQuantityChange(index, quantity - 1)}
                    className="px-2 py-1 bg-pink-400 text-white hover:bg-pink-500"
                  >
                    -
                  </button>
                  <input
                    type="number"
                    value={quantity}
                    min={1}
                    onChange={(e) => handleQuantityChange(index, e.target.value)}
                    className="w-10 text-center bg-transparent text-black border-x focus:outline-none appearance-none"
                    style={{
                      MozAppearance: "textfield",
                      WebkitAppearance: "none",
                    }}
                  />
                  <button
                    onClick={() => handleQuantityChange(index, quantity + 1)}
                    className="px-2 py-1 bg-pink-400 text-white hover:bg-pink-500"
                  >
                    +
                  </button>
                </div>
              </div>

              <div className="flex justify-between items-center mt-4 w-full">
                {/* --- START MODIFICATION FOR PRICE DISPLAY --- */}
                {showOffer ? (
                  // Display new price above old price with strikethrough
                  <div className="flex flex-col items-start leading-tight">
                    <span className="text-xl font-bold text-red-600">₹{displayedPrice.toFixed(2)}</span>
                    <span className="text-sm text-gray-500 line-through">₹{priceToDisplayAsOriginal.toFixed(2)}</span>
                  </div>
                ) : (
                  // Original price display if no valid offer
                  <span className="text-xl font-bold text-black">₹{priceToDisplayAsOriginal.toFixed(2)}</span>
                )}
                <button
                  className="bg-pink-500 text-white text-sm font-semibold px-4 py-1 rounded-xl shadow hover:bg-pink-600"
                  // Pass the displayedPrice (could be original or discounted)
                  onClick={() => onBuyNow && onBuyNow([{ name: product.productName, quantity, price: displayedPrice }])}
                >
                  Buy now
                </button>
              </div>
              <div className="h-[16px] flex items-start justify-end">
                {showOffer && ( // Conditional rendering based on product.productOffer
                  <span className="absolute top-4 right-2 bg-red-500 text-white font-bold text-lg px-2 py-1 rounded shadow-md animate-bounce">
                    {product.productOffer}
                  </span>
                )}
              </div>
            </motion.div>
          );
        })}
      </div>
      <div className="flex justify-center mt-6">
        <button
          onClick={handleGlobalBuyNow}
          className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-2 rounded-full shadow-lg"
        >
          Buy Now (Selected)
        </button>
      </div>
            {/* Scroll observer anchor */}
      <div ref={scrollObserver} className="h-10" />

      {/* {showPagination && (
        <div className="flex justify-center mt-6 gap-2">
          {Array.from({ length: pageCount }, (_, index) => (
            <motion.span
              key={index}
              className={`h-3 w-3 rounded-full transition-all duration-300 cursor-pointer ${index === activeIndex ? "bg-pink-600 scale-125" : "bg-pink-300"
                }`}
              whileHover={{ scale: 1.1 }}
              onClick={() => scrollToPage(index)}
            />
          ))}
        </div>
      )} */}
    </div>
  );
};

export default ProductSlider;
